module.exports = __webpack_public_path__ + "img/GVT.c4bd0f44.svg";